import Axios, { AxiosRequestConfig, InternalAxiosRequestConfig } from 'axios';
import applyCaseMiddleware from "axios-case-converter";
import { API_URL } from '@/config';

function authRequestInterceptor(config: AxiosRequestConfig): InternalAxiosRequestConfig {
  config.withCredentials = true;
  return config as InternalAxiosRequestConfig;
}

const axios = applyCaseMiddleware(Axios.create({
  baseURL: `${API_URL}/api/v1`,
  withCredentials: true,
  headers: {
    'Accept': 'application/json',
    'Access-Control-Allow-Origin': '*'
  }
}), {ignoreHeaders: true});

axios.interceptors.request.use(authRequestInterceptor);
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axios;